import type { VueRoute } from "ui-kit/RouterVue";
import { h } from "vue";

const route: VueRoute = {
  path: "/comissions/:slug?",
  action: async ({ pathname }) => {
    const id = pathname.groups.slug;
    const c = id
      ? await import("./views/comissionView.vue")
      : await import("./views/comissions.vue");
    return h(c.default, { id });
  },
};

export default route;
